import { mountNav } from '../components/Header';
import { createShare, deletePaste, listMyPastes } from '../api/client';

export function MyPastesPage(): void {
    const app = document.getElementById('app');
    if (!app) return;
    app.innerHTML = `
        <div class="container">
            <header class="header"><h1>Mediabin</h1><nav id="nav"></nav></header>
            <main class="main" id="my-pastes"><div class="loading">Loading...</div></main>
        </div>
    `;
    mountNav();
    loadMyPastes();
}

async function loadMyPastes(): Promise<void> {
    const container = document.getElementById('my-pastes');
    if (!container) return;
    try {
        const pastes = await listMyPastes();
        if (pastes.length === 0) {
            container.innerHTML = '<h2>My Pastes</h2><p>You have no pastes yet. <a href="/">Create one</a>.</p>';
            return;
        }
        let html = '<h2>My Pastes</h2><ul class="paste-list">';
        for (const p of pastes) {
            html += `
                <li>
                    <a href="/paste/${p.id}">${p.id}</a>
                    <span class="visibility-badge">${p.visibility}</span>
                    ${p.expires_at ? `<span class="expiry">expires ${new Date(p.expires_at).toLocaleDateString()}</span>` : ''}
                    <span class="views">${p.view_count} views</span>
                    <button class="btn btn-secondary" data-share="${p.id}">Share</button>
                    <a class="btn btn-secondary" href="/edit/${p.id}">Edit</a>
                    <button class="btn btn-secondary" data-delete="${p.id}">Delete</button>
                </li>
            `;
        }
        html += '</ul>';
        container.innerHTML = html;

        container.querySelectorAll<HTMLButtonElement>('[data-delete]').forEach((btn) => {
            btn.addEventListener('click', async () => {
                if (!window.confirm('Delete this paste permanently?')) return;
                try {
                    await deletePaste(btn.dataset.delete!);
                    await loadMyPastes();
                } catch (error) {
                    window.alert(error instanceof Error ? error.message : 'Delete failed');
                }
            });
        });

        container.querySelectorAll<HTMLButtonElement>('[data-share]').forEach((btn) => {
            btn.addEventListener('click', async () => {
                try {
                    const { share_url } = await createShare(btn.dataset.share!);
                    await navigator.clipboard.writeText(share_url);
                    btn.textContent = 'Link copied!';
                    setTimeout(() => { btn.textContent = 'Share'; }, 2000);
                } catch (error) {
                    window.alert(error instanceof Error ? error.message : 'Share failed');
                }
            });
        });
    } catch (error) {
        if (error instanceof Error && error.message === 'not authenticated') {
            window.location.href = '/login?next=/me';
            return;
        }
        container.innerHTML = `<div class="error"><p>${error instanceof Error ? error.message : 'Failed to load pastes'}</p></div>`;
    }
}
